import { makeStyles } from '@mui/styles'
import { getPixelInREM } from '../../../common/material'

export const useDriverTableStyles = makeStyles((theme) => ({
    chevron: {
        fontSize: getPixelInREM(12),
        [`&.open`]: {
            transform: `rotate(180deg)`
        }
    },
    cell: {
        fontSize: getPixelInREM(16),
        padding: `${getPixelInREM(16)} ${getPixelInREM(16)}`,
        width: 300
    },
    variantNav: {
        color: theme.palette.primary.main,
        cursor: 'pointer'
    },
    variantNoNav: {
        fontWeight: 600
    },
    noBorderBottom: {
        '& > *': {
            borderBottom: 'unset'
        }
    },
    chevronCell: {
        width: 30,
        padding: `${getPixelInREM(3)} ${getPixelInREM(5)}`
    },
    colWidth200: {
        width: 200
    },
    colWidth170: {
        width: 170
    }
}))
